import { render } from "./Trim.vue?vue&type=template&id=5efeadae&scoped=true"
import script from "./Trim.vue?vue&type=script&lang=js"
export * from "./Trim.vue?vue&type=script&lang=js"

import "./Trim.vue?vue&type=style&index=0&id=5efeadae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efeadae"]])

export default __exports__